module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_lines-ea802afc0763b44507a10845341c4349.gif";